import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { StatsBestseller, StatsCarrierUsage, StatsPaymentSale } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'
import { SchemaUtil } from '../../utils'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class ChartsStatsCheckoutService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  async getStatsBestsellers(
    from: string,
    to: string,
    checkoutId?: number,
    results?: number,
    schema: any = {
      amount: null,
      sales: {
        value: null,
        currency: {
          id: null,
        },
      },
      product: {
        id: null,
        name: null,
        fullName: null,
      },
    }
  ): Promise<{
    items: StatsBestseller[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.stats.getStatsBestsellers(from, to, checkoutId, results, schema)
  }

  async getStatsCarrierUsage(
    dateFrom,
    dateTo,
    checkoutId,
    schema: any = {
      amount: null,
      carrier: {
        id: null,
        name: null,
        color: null,
        position: null,
        tariffs: {
          id: null,
          const: null,
          name: null,
          cod: null,
          position: null,
        },
      },
    }
  ): Promise<{
    items: StatsCarrierUsage[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.stats.getStatsCarrierUsage(dateFrom, dateTo, checkoutId, schema)
  }

  async getStatsPaymentSale(
    dateFrom,
    dateTo,
    checkoutId,
    schema = {
      amount: null,
      sales: {
        value: null,
        currency: SchemaUtil.currency,
      },
      payment: SchemaUtil.payment,
    }
  ): Promise<{
    items: StatsPaymentSale[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.stats.getStatsPaymentSale(dateFrom, dateTo, checkoutId, schema)
  }
}
